import { render, staticRenderFns } from "./WorkflowIframe.vue?vue&type=template&id=cae48840&scoped=true"
import script from "./WorkflowIframe.vue?vue&type=script&lang=js"
export * from "./WorkflowIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae48840",
  null
  
)

export default component.exports